<div class="app" >
<app-header></app-header>
<router-outlet></router-outlet>
</div>
<!-- <app-footer></app-footer> -->